<template>
  <div>
    <div class="title">
      <div id="notice">
        <h5>考勤审核单说明:</h5>
        <span>1、业务说明:审核提交过来的请假单和调休单=>通过后修改对应考勤模板为请假状态!</span><br>
        <span>2、查询关键字:单号。</span><br>
      </div>
    </div>

    <pre-base ref="mybase" @base2-event="refresh_father" :pre_data="init_data">

      <!-- <template slot="slot_c_out_fee">
            <pre-select class="short0" ref="out_fee" @selectFunc="selectFunc1" v-bind:searchList="list_fee"
              :selectValue="sel_fee" />
          </template> -->

    </pre-base>
  </div>
</template>

<script>
  import api from '@/utils/type.js';
  import {
    Method_EasySelect
  } from '@/utils/loadhttpdata.js';
  export default {
    components: {
      "pre-base": () => import("../auto/old_view_v1.vue")
    },
    data() {
      return {
        init_data: '',
        row_id: '',
        item: '',
        // 下拉菜单
        // list_fee: [],
        // sel_fee: {},
      };
    },
    mounted: function() {
      var that = this;
      this.$nextTick(function() {
        that.fun_init();
      });
    },
    methods: {
      fun_init: async function() {

        let
          t_list_flag = [],
          t_list_user = [];

        // t_list_flag = await this.loadClass('data_flag');

        // t_list_user = await this.loadClass('data_alluser');

        this.init_data = '';
        this.init_data = JSON.stringify({
          "title": '考勤审核单申请',
          "control": "recordpass",
          "isTwo": "1",
          "action_flag": "",
          "sel_action_flag": "",  //更多查询
          "isFileMain": "1",
          "sel_action": 'exp_kq_rec_pass',
          "upd_action": 'exp15_kq_rec_pass',
          "d_sel_action": '',
          "d_upd_action": '',
          "file_action": '',
          "p1": '',
          "p2": '',
          "p3": '',
          "parm_sel": [
            {
              "name": "单号",
              "val": "",
              "key": "sheet_no",
              "type": "text",
              "class": "long2",
              "sel": "1"
            },
            // {
            //   "name": "申请人",
            //   "val": "",
            //   "key": "u_name",
            //   "type": "select",
            //   "class": "long1",
            //   "list": t_list_user.data,
            //   "sel_val": {},
            //   "sel_name": "",
            //   "sel": "2"
            // }
          ],
          "parm": [{
              "name": "单号",
              "val": "",
              "key": "sheet_no",
              "type": "text",
              "class": "long2",
              "p": "1",
              "r": "1",
              "x": "1"
            },
            // {
            //   "name": "申请人",
            //   "val": "",
            //   "key": "u2_name",
            //   "type": "select",
            //   "class": "long1",
            //   "list": t_list_user.data,
            //   "sel_val": {},
            //   "sel_name": "",
            //   "weight": "1",
            //   "p": "1",
            //   "x": "1"
            // },
            {
              "name": "申请明细",
              "val": "",
              "key": "detail",
              "type": "textarea",
              "class": "long5",
              "p": "0",
              "r": "1",
              "x": "2"
            },
            {
              "name": "备注",
              "val": "",
              "key": "note",
              "type": "text",
              "class": "long3",
              "p": "1",
              "x": "3"
            }
          ],
          "parm_th": [{
              "name": "序号"
            },
            {
              "name": "申请单"
            },
            {
              "name": "状态"
            },
            {
              "name": "备注"
            },
            {
              "name": "附件"
            },
            {
              "name": "申请明细"
            },

            {
              "name": "录入人"
            },
            {
              "name": "路径1"
            },
            {
              "name": "路径2"
            },
            {
              "name": "更新时间"
            }
          ],
          "d_parm": [],
          "d_name": []
        });

      },
      refresh_data: function(type) {
        var that = this;
        this.$nextTick(function() {
          that.$refs['mybase'].refresh_data(type);
        });
      },
      refresh_children: function(type, id, val) {
        var that = this;
        if (type == 'slot_c_out_fee') {
          this.$nextTick(function() {
            that.$refs['mybase'].refesh_parm(type, id, val, 'children');
          });
        } else {
          this.$message({
            message: '类别=!' + type + ' 没有配置相关操作!',
            type: 'error'
          });
        }
      },
      refresh_father: function(type, val, parm) {
        // console.log('type=' + type + ' val=' + val);
        switch (type) {
          case 'father':
            // 弹出修改明细，修改主窗口信息
            this.refresh_data();
            break;
          case 'blank':
            // 清空下拉菜单选项 没有起作用
            console.log('清空下拉菜单');
            this.sel_depart = {};
            break;
            // case 'slot_c_out_fee':
            //   this.selectFunc1(val);
            //   if (val == 'clear') {
            //     this.$refs['out_fee'].clearselect();
            //   }
            //   break;
          default:
            // console.log('子组件刷新父组件传值=' + val);
            this.row_id = val;
            this.item = parm;
            break;
        }
      },
      // selectFunc1: function(value) {
      //   // console.log('选择结果='+parm);
      //   for (var i = 0; i < this.list_fee.length; i++) {
      //     if (this.list_fee[i].id == value || this.list_fee[i].val == value) {
      //       this.refresh_children('slot_c_out_fee', this.list_fee[i].id, this.list_fee[i].val)
      //       break;
      //     }
      //   }
      // },
      loadClass: function(action, p1, p2, p3) {
        let that = this;
        return new Promise((resolve, reject) => {
          // console.log(menuvalue);
          that.$post(
            api.http_method, Method_EasySelect(action, p1, p2, p3)
          ).then(res => {
            res = JSON.parse(res);
            // console.log(res.data);
            resolve(res.data)
          });

        });
      },





    }
  };
</script>
<style>
</style>
